(function () {
  var textEl = document.querySelector('.announcement-bar__text');
  if (!textEl) return;

  var MARQUEE_CLASS = 'announcement-bar__text--marquee';
  var PX_PER_SECOND = 60;

  function update() {
    textEl.classList.remove(MARQUEE_CLASS);
    textEl.style.removeProperty('--marquee-duration');

    if (textEl.scrollWidth > textEl.clientWidth) {
      var distance = textEl.scrollWidth + window.innerWidth;
      textEl.style.setProperty('--marquee-duration', (distance / PX_PER_SECOND) + 's');
      textEl.classList.add(MARQUEE_CLASS);
    }
  }

  update();
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(update);
  }

  var timer;
  window.addEventListener('resize', function () {
    clearTimeout(timer);
    timer = setTimeout(update, 150);
  });
})();
